function Services() {
  const services = [
    {
      title: "Document Printing",
      desc: "Print or SCAN any type Document — PDF, DOCX, images and more with high quality.",
    },
    {
      title: "QR Upload Printing",
      desc: "Scan QR, upload your file instantly and print without any OTP or login.",
    },
    {
      title: "Instant Print",
      desc: "Fast printing system with no waiting time. Get your prints within seconds.",
    },
    {
      title: "Secure Printing",
      desc: "Your documents are safe and automatically deleted after printing.",
    },
  ];

  return (
    <section id="services" className="bg-black text-white py-20 px-6 md:px-20">

      {/* Heading */}
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-bold">
          Our <span className="text-green-400">Services</span>
        </h2>
        <p className="text-gray-400 mt-4">
          Fast, secure and modern printing solutions for everyone
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

        {services.map((item, index) => (
          <div
            key={index}
            className="p-6 border border-green-400/20 rounded-xl 
            bg-black/50 backdrop-blur-md 
            hover:border-green-400 transition duration-300
            hover:shadow-[0_0_20px_#00ff9f]"
          >
            <h3 className="text-xl font-semibold text-green-400 mb-3">
              {item.title}
            </h3>

            <p className="text-gray-400 text-sm">
              {item.desc}
            </p>
          </div>
        ))}

      </div>

    </section>
  );
}

export default Services;